import { createReducer } from "@reduxjs/toolkit";
import type { RetrievalState } from "@redux/state/shared-types";
import type { FundingRequestVM } from "@shared-kernel/application/ports/admin/admin-repository";
import { resetRetrieveFundingRequest, retrieveFundingRequest } from "./retrieve-funding-request";

const initialState: RetrievalState<FundingRequestVM | null> = {
  fetching: "idle",
  data: null,
};

export const retrieveFundingRequestReducer = createReducer<RetrievalState<FundingRequestVM | null>>(initialState, builder => {
  builder.addCase(retrieveFundingRequest.fulfilled, (state, { payload }) => {
    return {
      ...state,
      data: payload,
      fetching: "success",
    };
  });
  builder.addCase(retrieveFundingRequest.pending, state => {
    return {
      ...state,
      fetching: "pending",
    };
  });
  builder.addCase(retrieveFundingRequest.rejected, state => {
    return {
      ...state,
      fetching: "failed",
    };
  });
  builder.addCase(resetRetrieveFundingRequest, () => {
    return initialState;
  });
});
